import { combineReducers } from 'redux';

import auth from './views/auth/reducer';
import workflow from './views/workflow/reducer';
import wavelight from './views/wavelight/reducer';
import user from './views/users/reducer';

export default combineReducers({ auth, workflow, wavelight, user });
